import { API } from 'actions/actionTypes';

export const requestInFlight = (reducerKey, params = {}) => ({
  type: API.REQUEST_IN_FLIGHT,
  reducer: {
    key: reducerKey
  },
  params
});

export const requestSuccess = (data, reducerKey) => ({
  type: API.REQUEST_SUCCESS,
  data,
  reducer: {
    key: reducerKey
  }
});

export const requestFailed = (error, reducerKey) => ({
  type: API.REQUEST_FAILED,
  error,
  reducer: {
    key: reducerKey
  }
});

export const requestReset = reducerKey => ({
  type: API.RESET,
  reducer: {
    key: reducerKey
  }
});

export const requestClear = reducerKey => ({
  type: API.CLEAR_ERROR,
  reducer: {
    key: reducerKey
  }
});

export const requestDirty = reducerKey => ({
  type: API.DIRTY,
  reducer: {
    key: reducerKey
  }
});
